import {GenericInput} from '@hm/fundamental'
import React from 'react'
import {Controller, FieldValues} from 'react-hook-form'

import {handleNoSpecialCharacters} from '../../../common/utils/handleNoSpecialCharacters'
import {useTranslation} from '../../../hooks/useTranslation'
import {UserInformationInputSkeleton} from '../Skeleton/UserInformationInputSkeleton'

import {UserInformationProps} from './types'

export const UserCompanyInput = <T extends FieldValues>({
  readonlyMode,
  formMethods,
  isLoading,
  name
}: UserInformationProps<T>) => {
  const {t} = useTranslation()

  if (isLoading) {
    return <UserInformationInputSkeleton />
  }

  return (
    <Controller
      name={name}
      control={formMethods.control}
      rules={{validate: (value) => handleNoSpecialCharacters(value, t)}}
      render={({field, fieldState}) => (
        <GenericInput
          data-test-id={`userInformationForm-${field.name}`}
          label={t('userInformationForm.company')}
          value={readonlyMode && !field.value ? '-' : field.value}
          isReadOnly={readonlyMode}
          autoComplete="organization"
          id="companyName"
          isTouched={fieldState.isTouched}
          error={fieldState.error?.message}
          onChange={field.onChange}
        />
      )}
    />
  )
}
